// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.state-list__item {
  border-radius: 6px;
  width: 12px;
  height: 12px;
  margin-right: 15px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/StateList/StateList.css","webpack://./services/frontend/app/components/StateList/StateList.css"],"names":[],"mappings":"AADA;ECEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".state-list__item {\n  border-radius: 6px;\n  height: 12px;\n  margin-right: 15px;\n  width: 12px;\n}\n",".state-list__item {\n  border-radius: 6px;\n  width: 12px;\n  height: 12px;\n  margin-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
